<p class="hint">
    Restoring retrieves a temporary copy of your archived objects into Standard storage so they can be accessed. This
    does not permanently move them out of Deep Archive.
</p>
<p class="hint">
    Restores are not immediate. Deep Archive retrievals will take up to 48 hours to complete. Objects remain
    inaccessible until the restore finishes.
</p>
<p class="hint">
    Restored copies are available for a limited number of days, then expire back to Deep Archive. To keep objects in
    Standard storage permanently, change their storage class after the restore completes.
</p>

<nz-tag style="margin-bottom: 10px;"><nz-icon nzType="cloud-server" /> s3://{{ bucket() }}</nz-tag>

@if(nodes()){
<h4>Files — {{ eligibleBytes() | formatBytes }}</h4>
<nz-list nzSize="small" nzBordered>
    @for (file of eligibleFiles().slice(0, max); track file.key) {
    <nz-list-item style="display: flex; justify-content: space-between; align-items: center; width: 100%;">
        <div style="display: flex; align-items: center; flex: 1; min-width: 0; margin-right: 16px;">
            <nz-icon nzType="file" style="flex-shrink: 0;" />
            <span style="margin-left: 10px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                {{ file.key }}
            </span>
        </div>
        <span style="flex-shrink: 0;">{{ file.size | formatBytes }}</span>
    </nz-list-item>
    }
    @if (eligibleFiles().length > maxListed) {
    <nz-list-item>+ {{ eligibleFiles().length - maxListed }} more</nz-list-item>
    }
</nz-list>

@if (folders().length > 0){
<h4 style="margin-bottom: 0;">Folders</h4>
<span class="hint" style="padding: 0;">These will be traveresed, and all valid keys will be restored.</span>

<nz-list nzSize="small" nzBordered>
    @for (file of folders().slice(0, max); track file.key) {
    <nz-list-item>
        <div>
            <nz-icon nzType="folder" />
            <span style="margin-left: 10px;">{{ file.key }}</span>
        </div>
    </nz-list-item>
    }
    @if (folders().length > maxListed) {
    <nz-list-item>+ {{ folders().length - maxListed }} more</nz-list-item>
    }
</nz-list>
}

@if(skippedFiles().length > 0){
<h4>Skipped Files - (Not in Deep Archive of Glacier)</h4>
<nz-list nzSize="small" nzBordered>
    @for (file of skippedFiles().slice(0, max); track file.key) {
    <nz-list-item style="display: flex; justify-content: space-between; align-items: center; width: 100%;">
        <div style="display: flex; align-items: center; flex: 1; min-width: 0; margin-right: 16px;">
            <nz-icon nzType="file" style="flex-shrink: 0;" />
            <span style="margin-left: 10px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                {{ file.key }}
            </span>
        </div>

        <div style="flex-shrink: 0; display: flex; align-items: center;">
            <span>{{ file.size | formatBytes }}</span>
            <nz-tag style="margin: 0 0 0 8px;" [nzColor]="restored ? 'success' : classColor[file.storage_class]">
                {{ classLabel[restored ? 'STANDARD' : file.storage_class] }}
            </nz-tag>
        </div>
    </nz-list-item>
    }
    @if (skippedFiles().length > maxListed) {
    <nz-list-item>+ {{ skippedFiles().length - maxListed }} more</nz-list-item>
    }
</nz-list>

}

<div class="hint" style="margin: 10px 0 0 0;">
    Restoration will be performed for 30 days, after which these objects will be sent back to their respective storage
    classes.
    If you would like to keep them permanently, please get in touch with your admin.
</div>

}